import { useStoreActions, useStoreState } from '../../../../store/hooks'
import { Notations } from '../../components/Notations'

const DailyPuzzleNotations: React.FC = () => {
    const gameTree = useStoreState((state) => state.dailyPuzzleViewV2.gameTree)
    const notations = useStoreState((state) => state.dailyPuzzleViewV2.notations)
    const showSolution = useStoreState((state) => state.dailyPuzzleViewV2.showSolution)
    const puzzleState = useStoreState((state) => state.dailyPuzzleViewV2.puzzleState)
    const currentPosition = useStoreState((state) => state.dailyPuzzleViewV2.currentPosition)

    const setCurrentPosition = useStoreActions((state) => state.dailyPuzzleViewV2.setCurrentPosition)

    return (
        <Notations
            notations={notations}
            gameTree={gameTree}
            currentPosition={currentPosition}
            setCurrentPosition={setCurrentPosition}
            disabled={notations.length <= 1 || (showSolution && puzzleState === null)}
        />
    )
}

export default DailyPuzzleNotations
